import React, { useEffect, useState } from 'react';
import { MDBCard, MDBCardBody } from 'mdb-react-ui-kit';

const KPICards = () => {
  const [counts, setCounts] = useState({
    totalProducts: 0,
    todayProducts: 0,
    activeMarketplaces: 0,
    timeSaved: 0,
    costSaved: 0
  });

  const finalCounts = {
    totalProducts: 1247,
    todayProducts: 23,
    activeMarketplaces: 5,
    timeSaved: 156,
    costSaved: 4680
  };

  const animateCount = (key, target) => {
    let current = 0;
    const increment = target / 60;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(timer);
      }
      setCounts(prev => ({ ...prev, [key]: Math.floor(current) }));
    }, 30);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      Object.entries(finalCounts).forEach(([key, value]) => {
        animateCount(key, value);
      });
    }, 200);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const kpiData = [
    {
      title: 'Total Products Uploaded',
      value: counts.totalProducts.toLocaleString(),
      icon: '📦',
      trend: '+12.5%',
      period: 'vs last month'
    },
    {
      title: 'Products Today',
      value: counts.todayProducts.toLocaleString(),
      icon: '🚀',
      trend: '+8.2%',
      period: 'vs yesterday'
    },
    {
      title: 'Active Marketplaces',
      value: counts.activeMarketplaces.toLocaleString(),
      icon: '🏪',
      trend: '100%',
      period: 'coverage'
    },
    {
      title: 'Labor Hours Saved',
      value: counts.timeSaved.toLocaleString(),
      icon: '⏰',
      trend: '+18.3%',
      period: 'efficiency boost'
    },
    {
      title: 'Cost Saved',
      value: `$${counts.costSaved.toLocaleString()}`,
      icon: '💰',
      trend: '+24.7%',
      period: 'this month'
    }
  ];

  return (
    <div className="kpi-cards-container">
      {kpiData.map((kpi, index) => (
        <div key={index} className="kpi-col">
          <MDBCard className="kpi-card h-100">
            <MDBCardBody className="kpi-card-body">
              <div className="kpi-icon">{kpi.icon}</div>
              <div className="kpi-value">{kpi.value}</div>
              <div className="kpi-title">{kpi.title}</div>
              <div className="kpi-trend">
                <span className="trend-value">{kpi.trend}</span>
                <span className="trend-period">{kpi.period}</span>
              </div>
            </MDBCardBody>
          </MDBCard>
        </div>
      ))}
    </div>
  );
};

export default KPICards;